export const waitCnes = (ms, signal) => new Promise((resolve,reject)=>{
 const stop=()=>{clearTimeout(timer);reject(Object.assign(new Error('Cancelado'),{code:'ERR_CANCELED'}));};
 const timer=setTimeout(()=>{signal?.removeEventListener('abort',stop);resolve();},ms);
 if(signal?.aborted)stop();else signal?.addEventListener('abort',stop,{once:true});
});
export async function cnesRequest(call, signal, onWait=()=>{}) {
 for(let attempt=0;;attempt++) {
  try { return await call(); }
  catch(e) {
   if(e.response?.status!==429 || attempt>=3)throw e;
   const raw=e.response.headers?.['retry-after'];
   const numeric=Number(raw);
   const seconds=raw && Number.isFinite(numeric)?numeric:raw?Math.ceil((Date.parse(raw)-Date.now())/1000):60;
   const delay=Math.max(1,Math.min(300,Number.isFinite(seconds)?seconds:60));
   onWait(`Limite de consultas atingido. Nova tentativa em ${delay} segundos; os resultados foram preservados.`);
   await waitCnes(delay*1000,signal);
  }
 }
}
